import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import AdminCointainer from "../../containers/Admin";
import CustomTabs from "../../components/Tab";
import { useNavigate, useParams } from "react-router-dom";
import { downArrow, Plus } from "../../common/svg";
import Filter from "../../components/FilterButton";
import ReportButton from "../../components/ReportButton";
import CustomButton from "../../components/AddButton/index";
import DateTimePicker from "../../components/Date&Time";
import Routes from "./view/Routes";
import Vehicles from "./view/Vehicles";
import Documents from "./view/Documents";
import Expenses from "./view/Expenses";
import Tripdetails from "./view/TripDetails";
import { TripDetailstab } from "../../common/tabs";
import LiveStatusSection from "../../components/Live status/index";
import Carousel from "../../components/Carousel";
import SecureImage from "../../components/BucketImage/Image";
import CargoPage from "./view/Cargo";
import { ApiService } from "../../service/api.service";
import { OPERTIONS_URL, MASTER_URL } from "../../common/common";
import moment from "moment";
const Details = () => {
  const [activeTab, setActiveTab] = useState<string>("TripDetails");
  const [isExpanded, setIsExpanded] = useState(true);
  const [bookingDetails, setBookingDetails] = useState<any>(null);
  const [tripDetails, setTripDetails] = useState<any>(null);
  const [companyDetails, setCompanyDetails] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // NEW STATE FOR TRACKING URL
  const [trackingUrl, setTrackingUrl] = useState<string | undefined>(undefined);

  const { id } = useParams();
  const navigate = useNavigate();
  const apiService = new ApiService();

  // Fetch booking details and company details when component mounts
  useEffect(() => {
    if (id) {
      fetchBookingAndCompanyDetails();
    } else {
      setLoading(false);
      console.warn("No booking ID provided");
    }
  }, [id]);

  const fetchBookingAndCompanyDetails = async () => {
    try {
      setLoading(true);
      setError(null);

      // De-duplicate in-flight requests per tripId to avoid duplicate calls in StrictMode/dev
      const globalAny: any = window as any;
      if (!globalAny.__tripDetailsInFlight) {
        globalAny.__tripDetailsInFlight = new Map<string, Promise<any>>();
      }
      let responsePromise: Promise<any>;
      if (globalAny.__tripDetailsInFlight.has(id)) {
        responsePromise = globalAny.__tripDetailsInFlight.get(id);
      } else {
        responsePromise = apiService.getApi(
          `${OPERTIONS_URL}/trip/details-route?tripId=${id}`
        );
        globalAny.__tripDetailsInFlight.set(id, responsePromise);
      }

      let response: any = await responsePromise.finally(() => {
        // keep cache short-lived; allow future refreshes by deleting after resolution
        globalAny.__tripDetailsInFlight.delete(id);
      });

      // Extract the response data
      let data;
      if (response && typeof response === "object") {
        if ("data" in response) {
          data = (response as any).data;
        } else if ("body" in response && response.body) {
          data = (response as any).body.data || (response as any).body;
        } else {
          data = response;
        }
      } else {
        data = response;
      }

      let bookingData;
      if (Array.isArray(data)) {
        bookingData =
          data.find((item) => item.tripId === id || item.bookingId === id) ||
          data[0];
      } else {
        bookingData = data;
      }

      if (bookingData) {
        // Set booking/trip details
        setBookingDetails(bookingData);
        setTripDetails(bookingData);

        // Extract companyDetail from the same response
        if (bookingData.companyDetail) {
          setCompanyDetails(bookingData.companyDetail);
          console.log("Company Details Set:", bookingData.companyDetail);
        }

        // NEW: Fetch vehicle details with tracking URL from master data service
        if (bookingData.vehicleAssignments && bookingData.vehicleAssignments.length > 0) {
          const vehicleId = bookingData.vehicleAssignments[0]?.vehicleId;
          if (vehicleId) {
            console.log("🔍 Fetching vehicle details for vehicleId:", vehicleId);
            try {
              console.log("🔍 Making API call to:", `${MASTER_URL}/vehicle/get-one-route?vehicleId=${vehicleId}`);
              const vehicleResponse: any = await apiService.getApi(`${MASTER_URL}/vehicle/get-one-route?vehicleId=${vehicleId}`);
              console.log("🔍 Vehicle API response:", vehicleResponse);
              console.log("🔍 Vehicle API response status:", vehicleResponse?.status);

              if (vehicleResponse?.status === 200 || vehicleResponse?.status === "200") {
                console.log("🔍 Inside status 200 condition");
                console.log("🔍 Vehicle response body:", vehicleResponse.body);
                const vehicleTrackingUrl = vehicleResponse.body?.trackingUrl;
                console.log("🔍 Vehicle trackingUrl:", vehicleTrackingUrl);
                console.log("🔍 Vehicle trackingUrl type:", typeof vehicleTrackingUrl);

                if (vehicleTrackingUrl) {
                  setTrackingUrl(vehicleTrackingUrl);
                  console.log("✅ Tracking URL set for cargo:", vehicleTrackingUrl);
                } else {
                  console.log("⚠️ No tracking URL found in vehicle data");
                }
              } else {
                console.log("❌ Vehicle API response status not 200:", vehicleResponse?.status);
              }
            } catch (vehicleError) {
              console.error("❌ Error fetching vehicle details:", vehicleError);
            }
          } else {
            console.log("⚠️ No vehicleId found in vehicleAssignments");
          }
        } else {
          console.log("⚠️ No vehicleAssignments found in booking data");
        }

        setError(null);
      } else {
        setError("No booking details found for this trip.");
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      let errorMsg = "Unknown error occurred";
      if (error && typeof error === "object" && "message" in error) {
        errorMsg = (error as any).message;
      }
      setError(`Error: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  const fetchCompanyDetails = async () => {
    try {
      // Use the same API endpoint that returns companyDetail
      const response = await apiService.getApi(
        `${OPERTIONS_URL}/trip/details-route?tripId=${id}`
      );

      // Extract the response data
      let data;
      if (response && typeof response === "object") {
        if ("body" in response && response.body) {
          data = (response as any).body.data || (response as any).body;
        } else if ("data" in response) {
          data = (response as any).data;
        } else {
          data = response;
        }
      } else {
        data = response;
      }

      // Find companyDetail in the response
      let companyData = null;

      if (Array.isArray(data)) {
        // If data is array, find the item and extract companyDetail
        const item =
          data.find((item) => item.tripId === id || item.bookingId === id) ||
          data[0];
        companyData = item?.companyDetail;
      } else if (data?.companyDetail) {
        // If data is object with companyDetail
        companyData = data.companyDetail;
      }

      console.log("Company Data:", companyData); // Debug log

      if (companyData) {
        setCompanyDetails(companyData);
      } else {
        console.warn("No company details found in response");
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleTabChange = (tab: string) => {
    if (tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div>
      <Header
        profile={
          "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
        }
        title={
          tripDetails?.tripName || tripDetails?.tripDetail?.tripName || "N/A"
        }
        showSearch={false}
        contact={moment(tripDetails?.startingDateTime).format(
          "DD MMMM YYYY, hh:mma"
        )}
        subtitle={
          tripDetails?.tripNumber
            ? `#${tripDetails.tripNumber}`
            : tripDetails?.tripDetail?.tripNumber
              ? `#${tripDetails.tripDetail.tripNumber}`
              : "N/A"
        }

      >
        <div className="flex gap-2 tripName">
          <DateTimePicker />
          <Filter />
          <ReportButton />
          <CustomButton
            label=""
            icon={Plus}
            onClick={() => navigate("newtrip")}
          />
        </div>
      </Header>

      <AdminCointainer>
        <div className="mt-5">
          <div
            className={`bg-white rounded-[20px] h-[120px] transition-all duration-300 ease-in-out overflow-hidden ${isExpanded ? "max-h-[500px]" : "max-h-0"
              }`}
          >
            <div className="ml-10 rounded-[20px] p-4">
              <div className="flex items-center justify-between">
                <div className="text-gray-700 text-sm">
                  {/* Booking Name */}
                  <div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E]  whitespace-nowrap">
                        Booking Name
                      </p>
                      <p className="flex items-center  justify-between font-poppins text-[12px] font-[400] text-[#282828]">
                        {tripDetails?.bookingName ||
                          tripDetails?.bookingDetail?.bookingName ||
                          "N/A"}
                      </p>
                    </div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E] mt-4  whitespace-nowrap">
                        EWay Bill
                      </p>
                      <p className="font-poppins text-[13px] font-[400] text-[#282828] ml-2 whitespace-nowrap">
                        {tripDetails?.eWayBill ||
                          tripDetails?.tripDetail?.eWayBill ||
                          "N/A"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="text-gray-700 text-sm">
                  {/* Trip Name */}
                  <div>

                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E]   whitespace-nowrap">
                        Booking Type
                      </p>
                      <p className="">
                        {tripDetails?.bookingDetail?.bookingType ||
                          tripDetails?.bookingType ||
                          "N/A"}
                      </p>
                    </div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E] mt-4  whitespace-nowrap">
                        LR Number
                      </p>
                      <p className="font-poppins text-[13px] font-[400] text-[#282828] ">
                        {tripDetails?.lrNumber ||
                          tripDetails?.tripDetail?.lrNumber ||
                          "N/A"}
                      </p>

                    </div>
                  </div>
                </div>

                <div className="text-gray-700 text-sm">
                  {/* Created By */}
                  <div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px]  text-[#7E7E7E]  whitespace-nowrap">
                        Created By
                      </p>
                      <p className="text-[#444FBD] font-medium cursor-pointer text-[13px]  whitespace-nowrap">
                        {tripDetails?.createdBy || "Praveen Elumalai"}
                      </p>

                    </div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px]  text-[#7E7E7E] mt-4  whitespace-nowrap">
                        Phone No
                      </p>
                      <p className="font-medium text-[13px]">
                        {companyDetails?.phoneNumber || "+91 12345 67890"}
                      </p>

                    </div>
                  </div>
                </div>

                <div className="border-l-2  border-dashed border-gray-500 h-12"></div>

                <div className="text-gray-700 text-sm ">
                  {/* Client */}
                  <div className="">
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E]  ">
                        Client
                      </p>
                      <p className="text-[#444FBD] font-medium text-[13px] cursor-pointer whitespace-nowrap">
                        {tripDetails?.executiveDetail?.firstName || "N/A"}{" "}
                        {tripDetails?.executiveDetail?.lastName || ""}
                      </p>

                    </div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E]  mt-4  whitespace-nowrap">
                        Phone No
                      </p>
                      <p className="font-poppins text-[13px] font-[400] text-[#282828] whitespace-nowrap">
                        {companyDetails?.phoneNumber || "+91 12345 67890"}
                      </p>

                    </div>
                  </div>
                </div>

                <div className="text-gray-700 text-sm ">
                  {/* Company */}
                  <div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E]  ">
                        Company
                      </p>
                      <p className="text-[#444FBD] font-medium text-[13px] cursor-pointer whitespace-nowrap ">
                        {companyDetails?.companyName ||
                          "Maersk Technologies Pvt Ltd"}
                      </p>

                    </div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E]  mt-4">
                        Mail ID
                      </p>
                      <p className="font-medium text-[13px]">
                        {companyDetails?.email || "support@maersk.com"}
                      </p>
                    </div>

                  </div>
                </div>

                <div className="text-gray-700 text-sm ">
                  {/* Location */}
                  <div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E] ">
                        Location
                      </p>
                      <p className=" font-poppins text-[13px] font-[400] text-[#282828]">
                        {companyDetails?.city || "Bangalore"},{" "}
                        {companyDetails?.country || "India"}
                      </p>

                    </div>
                    <div className="flex items-center justify-between flex-col">
                      <p className="font-poppins text-[12px] text-[#7E7E7E] mt-4 ">
                        GST
                      </p>
                      <p className="font-medium text-[13px]">
                        {companyDetails?.gst || "AAY64545FG65676"}
                      </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Toggle Button */}
          <div className="flex justify-center items-center mt-2 relative ml-[60px]">
            <button
              onClick={toggleExpand}
              aria-expanded={isExpanded}
              className="flex justify-center mr-[110px] items-center bg-white w-[30px] h-[30px] absolute bottom-[-1] rounded-full shadow-[0px_0.5px_1px_0.5px_rgba(0,0,0,0.25)]"
            >
              <SecureImage
                fileKey={downArrow}
                alt={isExpanded ? "Collapse" : "Expand"}
                className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""
                  }`}
                width="89px"
              />
            </button>
          </div>
        </div>

        <div>
          <LiveStatusSection />
        </div>

        <br />

        <div>
          <CustomTabs
            tabs={TripDetailstab}
            initialActiveTab="TripDetails"
            onTabChange={handleTabChange}
          />
        </div>

        <div>
          {activeTab === "TripDetails" && <Tripdetails />}
          {activeTab === "Routes" && <Routes id={id} tripData={tripDetails} vehicleAssignments={tripDetails?.vehicleAssignments} />}
          {activeTab === "Vehicles" && <Vehicles id={id} tripData={tripDetails} vehicleAssignments={tripDetails?.vehicleAssignments} />}
          {activeTab === "Cargo" && <CargoPage trackingUrl={trackingUrl} tripId={id} />}
          {activeTab === "Documents" && <Documents />}
          {activeTab === "Expenses" && <Expenses images={[]} />}
        </div>
      </AdminCointainer>
    </div>
  );
};

export default Details;
